const View = Object.freeze({

    ORDEM_DE_SERVICO_DISTRIBUICAO_DE_REQUISICAO_DE_COMPRAS: "ordemdeservico-distribuicao-de-requisicao-de-compras",
    ORDEM_DE_SERVICO_DISTRIBUICAO_DE_REQUISICAO_DE_COMPRAS_COMPRADORES: "ordemdeservico-distribuicao-de-requisicao-de-compras-compradores",

    JOB: "job",
    JOB_COORDENADORES_DE_CONTRATOS: "job-coordenadores-de-contratos",
    JOB_NCMS: "job-ncms",
    JOB_TIPOS_DE_TRANSPORTE: "job-tipos-de-transporte",
    
    JOB_ITEM_TIPOS_DE_EQUIPAMENTO: "job-item-tipos-de-equipamento",

    JOB_PARCELAS: "job-parcelas",

    REQUISICAO_DE_COMPRA_CRIAR_COTACAO_DE_PEDIDO_DE_COMPRA:"requisicao-de-compra-criar-cotacao-de-pedido-de-compra",

    COTACAO_PEDIDO_DE_COMPRA_CRIAR_PEDIDO_DE_COMPRA:"cotacao-de-pedido-de-compra-criar-pedido-de-compra",
    COTACAO_PEDIDO_DE_COMPRA_ESTA_ENCERRADA:"cotacao-de-pedido-de-compra-esta-encerrada",
    COTACAO_PEDIDO_DE_COMPRA_FORNECEDORES:"cotacao-de-pedido-de-compra-fornecedores",
    COTACAO_PEDIDO_DE_COMPRA_PARCELAS_CONDICAO_DE_PAGAMENTO:"cotacao-de-pedido-de-compra-parcelas-condicoes-de-pagamento",
    COTACAO_PEDIDO_DE_COMPRA_ORDEM_DE_SERVICO_ITENS_UNIDADES:"cotacao-de-pedido-de-compra-ordem-de-servico-itens-unidades",

    PEDIDO_DE_COMPRA_VISUALIZAR_PEDIDOS_DE_COMPRA:"pedido-de-compra-visualizar-pedidos-de-compra",
    PEDIDO_DE_COMPRA_APROVACAO_COORDENADORES:"pedido-de-compra-aprovacao-coordenadores",
    PEDIDO_DE_COMPRA_APROVACAO_DIRETOR:"pedido-de-compra-aprovacao-diretor",
    PEDIDO_DE_COMPRA_APROVACAO_COMPRADOR:"pedido-de-compra-aprovacao-comprador",
    PEDIDO_DE_COMPRA_ENVIAR_PEDIDO:"pedido-de-compra-enviar-pedido",
    PEDIDO_DE_COMPRA_CRIAR_FOLLOWUP:"pedido-de-compra-criar-followup",
    PEDIDO_DE_COMPRA_SOLICITAR_REVISAO:"pedido-de-compra-solicitar-revisao",

    PEDIDO_DE_COMPRA_ALTERAR_PEDIDO_DE_COMPRA:"pedido-de-compra-alterar-pedido-de-compra",
    PEDIDO_DE_COMPRA_ALTERAR_PEDIDO_DE_COMPRA_FORNECEDORES:"pedido-de-compra-alterar-pedido-de-compra-fornecedores",
    PEDIDO_DE_COMPRA_ALTERAR_PEDIDO_DE_COMPRA_PARCELAS_CONDICAO_DE_PAGAMENTO:"pedido-de-compra-alterar-pedido-de-compra-parcelas-condicoes-de-pagamento",
    PEDIDO_DE_COMPRA_ALTERAR_PEDIDO_DE_COMPRA_ORDEM_DE_SERVICO_ITENS_UNIDADES: "pedido-de-compra-alterar-pedido-de-compra-ordem-de-servico-itens-unidades",
    PEDIDO_DE_COMPRA_ALTERAR_PEDIDO_DE_COMPRA_COTACOES_DE_PEDIDO_DE_COMPRA: "pedido-de-compra-alterar-pedido-de-compra-cotacacoes-de-pedido-de-compra",

    PEDIDO_DE_COMPRA_REVISAO_DE_PEDIDO_DE_COMPRA:"pedido-de-compra-revisao-de-pedido-de-compra",
    PEDIDO_DE_COMPRA_REVISAO_DE_PEDIDO_DE_COMPRA_FORNECEDORES:"pedido-de-compra-revisao-de-pedido-de-compra-fornecedores",
    PEDIDO_DE_COMPRA_REVISAO_DE_PEDIDO_DE_COMPRA_PARCELAS_CONDICAO_DE_PAGAMENTO:"pedido-de-compra-revisao-de-pedido-de-compra-parcelas-condicoes-de-pagamento",
    PEDIDO_DE_COMPRA_REVISAO_DE_PEDIDO_DE_COMPRA_ORDEM_DE_SERVICO_ITENS_UNIDADES: "pedido-de-compra-revisao-de-pedido-de-compra-ordem-de-servico-itens-unidades",
    PEDIDO_DE_COMPRA_REVISAO_DE_PEDIDO_DE_COMPRA_COTACOES_DE_PEDIDO_DE_COMPRA: "pedido-de-compra-revisao-de-pedido-de-compra-cotacacoes-de-pedido-de-compra",
    
    CONTAS_A_PAGAR: "contas-a-pagar",
    CONTAS_A_PAGAR_GERAR_PAGAMENTOS_NOTAS_FISCAIS_RECEBIDAS: "contas-a-pagar-gerar-pagamentos-notas-fiscais-recebidas",

    PAGAMENTOS_ELETRONICOS_RH_PAGAMENTOS_ELETRONICOS: "pagamentos-eletronicos-rh-pagamentos-eletronicos",
    PAGAMENTOS_ELETRONICOS_FINANCEIRO_PAGAMENTOS_ELETRONICOS: "pagamentos-eletronicos-financeiro-pagamentos-eletronicos",
    PAGAMENTOS_ELETRONICOS_VISUALIZAR_PAGAMENTOS_ELETRONICOS: "pagamentos-eletronicos-visualizar-pagamentos-eletronicos",

    PAGAMENTOS_ELETRONICOS_DE_FOLHA_DE_PAGAMENTO_GERAR_ARQUIVO_REM: "pagamentos-eletronicos-de-folha-de-pagamento-gerar-arquivo-rem",
    PAGAMENTOS_ELETRONICOS_DE_FERIAS_GERAR_ARQUIVO_REM: "pagamentos-eletronicos-de-ferias-gerar-arquivo-rem",
    PAGAMENTOS_ELETRONICOS_DE_RESCISOES_GERAR_ARQUIVO_REM: "pagamentos-eletronicos-de-rescisoes-gerar-arquivo-rem",
    PAGAMENTOS_ELETRONICOS_DE_PENSOES_ALIMENTICIAS_GERAR_ARQUIVO_REM: "pagamentos-eletronicos-de-pensoes-alimenticias-gerar-arquivo-rem",

    ITENS_RE: "itens-re",

    CONTAS_A_RECEBER: "contas-a-receber",
    CONTAS_A_RECEBER_CONTAS_FINANCEIRAS: "contas-a-receber-contas-financeiras",
    CONTAS_A_RECEBER_NOTAS_FISCAIS_VINCULAVEIS: "contas-a-receber-notas-fiscais-vinculaveis",
    CONTAS_A_RECEBER_CRIAR_CONTA_A_RECEBER_AVULSA_JOBS:"contas-a-receber-criar-conta-a-receber-avulsa-jobs",

});

export default View;